import {Icon, IconRegistry} from 'platform/foundation-tw';

import {MiraIconKey, miraIcons} from '../../icons/miraIcons';

const iconRegistry: IconRegistry = new Proxy({} as IconRegistry, {
  get(_target, prop: string) {
    const entry = miraIcons[prop as MiraIconKey];
    return entry?.Component;
  },
  has(_target, prop: string) {
    return prop in miraIcons;
  },
  ownKeys() {
    return Object.keys(miraIcons);
  },
  getOwnPropertyDescriptor() {
    return {enumerable: true, configurable: true};
  },
});

export function MiraIcon({name}: {name: MiraIconKey}) {
  return <Icon value={name} iconRegistry={iconRegistry} />;
}
